// PopupModal.js
import React from "react";
import "../styles/PopupModal.css";

export default function PopupModal({ message, onClose }) {
  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <div className="popup-header"></div>
        <div className="popup-content">
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
}